(() => {
  if (window.leRetroSwitchSoundReady) return;
  window.leRetroSwitchSoundReady = true;
  const clips = new Map();
  let active;
  function clip(url) {
    if (!clips.has(url)) {
      const audio = new Audio(url);
      audio.preload = 'auto';
      audio.volume = .45;
      clips.set(url, audio);
    }
    return clips.get(url);
  }
  function prepare(root = document) {
    root.querySelectorAll('[data-retro-switch]').forEach(button => {
      if (button.dataset.soundOn) clip(button.dataset.soundOn);
      if (button.dataset.soundOff) clip(button.dataset.soundOff);
    });
  }
  prepare();
  document.addEventListener('shopify:section:load', event => prepare(event.target));
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-retro-switch]');
    if (!button) return;
    // Read the visual state; the existing theme handler owns switching.
    const dark = button.hasAttribute('data-theme-toggle')
      ? document.documentElement.dataset.theme === 'dark'
      : button.closest('.lights')?.classList.contains('is-off');
    const url = dark ? button.dataset.soundOn : button.dataset.soundOff;
    if (!url) return;
    try {
      if (active) { active.pause(); active.currentTime = 0; }
      active = clip(url);
      active.currentTime = 0;
      const playing = active.play();
      if (playing) playing.catch(() => {});
    } catch (_) { /* Switching remains available when audio is blocked. */ }
  });
})();
